// Re-exported from bound-field-props — import from there directly.
export type { InheritableBoundFieldState, PrefilledFieldState } from './bound-field-props'
export {
  resolveInheritedFieldState,
  hasFieldValue,
  createPrefilledFieldState,
  beginPrefilledEdit,
  cancelPrefilledEdit,
} from './bound-field-props'
